export const useWebviewExtraHeaders = () => {
  return useCookie<Record<string, string> | null>("extra_headers");
};
